module.exports = __webpack_public_path__ + "img/location-singapore-2.b90ae3a8.jpg";